import * as React from "react";
import WidgetsIcon from "@mui/icons-material/Widgets";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { IRecordFurtherEducationNode } from "ui/Scripts/source/models/recordFurtherEducation/recordFurtherEducationNode";
import { Translations } from "ui/Scripts/source/models/translations";
import { Grid, Tooltip, Typography, alpha } from "@mui/material";
import { ListLinkValue } from "source/components/framework/List/ListLinkValue";

export interface IRecordFurtherEducationTreeNodeProp {
    classes?: string;
    level: number;
    item: IRecordFurtherEducationGroupNode | IRecordFurtherEducationNode;
    selectedId?: string;
    onClick: (id: string) => void;
    onDoubleClick: (id: string) => void;
    onSetCollapsed: (id: string, value: boolean) => void;
}

export class RecordFurtherEducationTreeNode extends React.Component<IRecordFurtherEducationTreeNodeProp, {}> {
    handleNodeClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onClick(props.item.id);
    };
    
    handleNodeDoubleClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onDoubleClick(props.item.id);
    };

    render() {
        const props = this.props;
        const item = props.item;
        const isGroup = RecordFurtherEducationGroupNode.isGroup(item);
        if (!item || (!isGroup && item.parentIsCollapsed())) return null;
        return (
            <>
                <Grid
                    container
                    onClick={this.handleNodeClick} onDoubleClick={props.onDoubleClick ? this.handleNodeDoubleClick : null}
                    sx={(theme) => ({
                        "paddingY": "11px",
                        "borderBottom": "1px solid",
                        "borderColor": "divider",
                        "cursor": "pointer",
                        "backgroundColor": props.selectedId === item.id
                            ? alpha(
                                theme.palette.primary.main,
                                theme.palette.action.selectedOpacity
                            )
                            : undefined,
                        "&:hover": {
                            background: props.selectedId === item.id
                                ? alpha(
                                    theme.palette.primary.main,
                                    theme.palette.action.selectedOpacity +
                                                theme.palette.action.hoverOpacity
                                )
                                : theme.palette.action.hover
                        }
                    })}
                >
                    <Grid item sm={5} sx={{ paddingLeft: (10 * props.level + (isGroup ? 0 : 20)).toString(10) + "px" }}>
                        {isGroup &&
                            <Tooltip title={Translations.FurtherEducationGroup}>
                                <WidgetsIcon fontSize="small" sx={{ marginRight: "5px" }} />
                            </Tooltip>
                        }
                        <ListLinkValue onClick={props.onDoubleClick ? this.handleNodeDoubleClick : null} title={item.code}>{item.code}</ListLinkValue>
                    </Grid>
                    <Grid item sm={5} sx={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>{item.comment}</Grid>
                    <Grid item sm={2}>
                        {isGroup && item.requiredQualificationCount > 0 &&
                            <Typography title={item.requiredQualificationCount.toString(10)} sx={{ paddingLeft: ".5rem" }}>{item.requiredQualificationCount.toString(10)}</Typography>
                        }
                        {isGroup && item.requiredQualificationCount === 0 &&
                            <Typography title={Translations.NotInUse} sx={{ paddingLeft: ".5rem" }}>{Translations.NotInUse}</Typography>
                        }
                    </Grid>
                </Grid>
                {isGroup && item.children.map((childItem) =>
                    <RecordFurtherEducationTreeNode
                        key={childItem.id}
                        item={childItem}
                        level={props.level + 1}
                        selectedId={props.selectedId}
                        onClick={props.onClick}
                        onDoubleClick={props.onDoubleClick}
                        onSetCollapsed={props.onSetCollapsed}
                    />
                )}
            </>
        );
    }
}